export default "__VITE_ASSET__DuDpDNOT__"